import React, { useState } from "react";
import { NavLink, Link } from "react-router-dom";

import LogoLight from "../assets/images/logo-light.webp";
import LogoDark from "../assets/images/logo-dark.webp";

export default function Navbar(props) {
  const { navClass, topnavClass, tagLine } = props;

  let [toggle, setToggle] = useState(false);
  let [manu] = useState("");
  let [scroll] = useState(true);

  return (
    <React.Fragment>
      <nav
        id="topnav"
        className={`defaultscroll is-sticky ${scroll ? "nav-sticky" : ""} ${
          tagLine ? "tagline-height" : ""
        } ${topnavClass ? topnavClass : ""} 
            `}
      >
        <div
          className={`${
            topnavClass !== "" && topnavClass !== undefined
              ? "container-fluid md:px-8 px-3"
              : "container"
          }`}
        >
          {/* <!-- Logo container --> */}
          <Link className="logo" to="/">
            <span className="inline-block dark:hidden">
              <img
                src={LogoDark}
                alt="Panoramic Mountain Group"
                className="h-10 md:h-24 w-auto object-contain"
                loading="eager"
                width="240"
                height="96"
              />
            </span>
            <span className="hidden dark:inline-block">
              <img
                src={LogoLight}
                alt="Panoramic Mountain Group"
                className="h-10 md:h-24 w-auto object-contain"
                loading="eager"
                width="240"
                height="96"
              />
            </span>
          </Link>
          {/* <!-- End Logo container --> */}

          {/* <!-- Start Mobile Toggle --> */}
          <div className="menu-extras">
            <div className="menu-item">
              <Link
                to="#"
                className={`${toggle ? "open" : ""} navbar-toggle`}
                id="isToggle"
                onClick={() => setToggle(!toggle)}
              >
                <div className="lines">
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
              </Link>
            </div>
          </div>

          <div id="navigation" style={{ display: toggle ? "block" : "none" }}>
            {/* <!-- Navigation Menu--> */}
            <ul
              className={`navigation-menu  ${
                navClass === "" || navClass === undefined ? "" : "nav-light"
              }   ${
                topnavClass !== "" && topnavClass !== undefined
                  ? "justify-center"
                  : "justify-end"
              }`}
            >
              <li className={manu === "/sell" ? "active" : ""}>
                <NavLink
                  to="/list"
                  activeclassname="active"
                  className="sub-menu-item"
                >
                  Properties
                </NavLink>
              </li>

              <li className={manu === "/aboutus" ? "active" : ""}>
                <Link to="/aboutus" className="sub-menu-item">
                  About PMG
                </Link>
              </li>

              <li className={manu === "/contact" ? "active" : ""}>
                <Link to="/contact" className="sub-menu-item">
                  Contact
                </Link>
              </li>

              <li className={manu === "/highlands" ? "active" : ""}>
                <Link to="/highlands" className="sub-menu-item">
                  Highlands
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>
      {/* End Navbar  */}
    </React.Fragment>
  );
}
